
// Normalize locale to known suffix key
const suffixes = {
    "en-GB": { M: "M", B: "B", T: "T", Q: "Q" },
    "en-US": { M: "M", B: "B", T: "T", Q: "Q" },
    "en-IN": { M: "L", B: "Cr", T: "Arb", Q: "Kharab" },
    hi: { M: "लाख", B: "करोड़", T: "अरब", Q: "खरब" },
    es: { M: "M", B: "Mil M", T: "B", Q: "Mil B" },
    fr: { M: "M", B: "Md", T: "Bn", Q: "Bn+" },
    ja: { M: "百万", B: "十億", T: "兆", Q: "京" },
    ar: { M: "مليون", B: "مليار", T: "تريليون", Q: "كوادريليون" },
    ru: { M: "млн", B: "млрд", T: "трлн", Q: "квдрлн" },
    pt: { M: "Mi", B: "Bi", T: "Tri", Q: "Quad" },
    id: { M: "Jt", B: "M", T: "T", Q: "Q" },
    fa: { M: "میلیون", B: "میلیارد", T: "تریلیون", Q: "کوادریلیون" },
    tr: { M: "Mn", B: "Mr", T: "Tr", Q: "Katr" },
    ko: { M: "백만", B: "십억", T: "조", Q: "경" },
    de: { M: "Mio.", B: "Mrd.", T: "Bio.", Q: "Brd." },
    it: { M: "Mln", B: "Mld", T: "Tln", Q: "Qdn" },
    uk: { M: "млн", B: "млрд", T: "трлн", Q: "квдрлн" },
    nl: { M: "mln", B: "mld", T: "bln", Q: "trl" },
    zh: { M: "百万", B: "十亿", T: "万亿", Q: "千兆" },
    cs: { M: "mil.", B: "mld.", T: "bil.", Q: "bil.+" },
    ur: { M: "لاکھ", B: "کروڑ", T: "ارب", Q: "کھرب" },
    da: { M: "Mio.", B: "Mia.", T: "Bio.", Q: "Tio." },
    tl: { M: "M", B: "B", T: "T", Q: "Q" },
    ms: { M: "J", B: "B", T: "T", Q: "Q" },
    fi: { M: "milj.", B: "mrd.", T: "bilj.", Q: "trilj." },
    vi: { M: "Tr", B: "Tỷ", T: "Nghìn tỷ", Q: "Triệu tỷ" },
    th: { M: "ล้าน", B: "พันล้าน", T: "ล้านล้าน", Q: "ล้านล้านล้าน" },
  };
  
  export default suffixes;

  
function normalizeLocale(locale = "en-US") {
  if (!locale) return "en-US";

  const supportedLocales = Object.keys(suffixes);
  if (supportedLocales.includes(locale)) return locale;

  // Fallback by prefix
  const langPrefix = locale.split("-")[0];

  const fallbackMap = {
    en: "en-US",
    hi: "hi",
    fr: "fr",
    es: "es",
    ja: "ja",
    ar: "ar",
    ru: "ru",
    pt: "pt",
    id: "id",
    fa: "fa",
    tr: "tr",
    ko: "ko",
    de: "de",
    it: "it",
    uk: "uk",
    nl: "nl",
    zh: "zh",
    cs: "cs",
    ur: "ur",
    da: "da",
    tl: "tl",
    ms: "ms",
    fi: "fi",
    vi: "vi",
    th: "th",
  };

  return fallbackMap[langPrefix] || "en-US";
}

export function formatNumberShort(num, locale = "en-US") {
  if (num == null) return "--";

  const absNum = Math.abs(num);
  const normalized = normalizeLocale(locale);
  const suffix = suffixes[normalized];

  if (absNum <= 1_000_000_000) {
    return num.toLocaleString(locale);
  }

//   if (absNum < 1e9) return (num / 1e6).toFixed(2) + " " + suffix.M;
  if (absNum < 1e12) return (num / 1e9).toFixed(2) + " " + suffix.B;
  if (absNum < 1e15) return (num / 1e12).toFixed(2) + " " + suffix.T;
  if (absNum < 1e18) return (num / 1e15).toFixed(2) + " " + suffix.Q;

  return num.toExponential(2); // fallback for extreme numbers
}

export function formatNumberShortForGraph(num, locale = "en-US") {
    if (num == null) return "--";
  
    const absNum = Math.abs(num);
    const normalized = normalizeLocale(locale);
    const suffix = suffixes[normalized];
  
    if (absNum <= 1_000) {
      return num.toLocaleString(locale); // Show full up to 1 million
    }
    if (absNum < 1e9) return (num / 1e6).toFixed(2) + " " + suffix.M;
    if (absNum < 1e12) return (num / 1e9).toFixed(2) + " " + suffix.B;
    if (absNum < 1e15) return (num / 1e12).toFixed(2) + " " + suffix.T;
    if (absNum < 1e18) return (num / 1e15).toFixed(2) + " " + suffix.Q;
  
    return num.toExponential(2); // fallback
  }
  
